export class CMProfileSchool {

    public _id: string;
    public name: string;
    public title: string;
    public location: string;

    public isCurrentStudy: boolean;

    public monthFrom: number;
    public yearFrom: number;

    public monthTo: number;
    public yearTo: number;

    public constructor() {
        const now = new Date();
        this._id = '';
        this.name = '';
        this.title = '';
        this.location = '';
        this.isCurrentStudy = false;
        this.monthFrom = now.getMonth();
        this.monthTo = now.getMonth();
        this.yearFrom = now.getFullYear();
        this.yearTo = now.getFullYear();
    }

    public fromRaw(data: IProfileSchoolData) {
        const now = new Date();
        this._id = data._id || '';
        this.name = data.name || '';
        this.title = data.title || '';
        this.location = data.location || '';
        this.isCurrentStudy = data.isCurrentStudy || false;
        this.monthFrom = data.monthFrom || now.getMonth();
        this.yearFrom = data.yearFrom || now.getFullYear();
        this.monthTo = data.monthTo || now.getMonth();
        this.yearTo = data.yearTo || now.getFullYear();
        return this;
    }

}

export interface IProfileSchoolData {
    _id: string;
    name: string;
    title: string;
    location: string;

    isCurrentStudy: boolean;

    monthFrom: number;
    yearFrom: number;

    monthTo: number;
    yearTo: number;
}